// Navigation
export const BP_NAV_HEADER_TEXT = 450;
export const BP_NAV_DRAWER_FULL = 650;
export const BP_NAV_COLLAPSE = 1500;

// Footer
export const BP_FOOTER_SITEMAP_INLINE = 700;

// Home / Bio
export const BP_BIO_TWO_COL = 850;
export const BP_BIO_THREE_COL = 1375;
export const BP_BIO_DIGEST_INLINE = 1500;
export const BP_BIO_THREE_COL_DIGEST = 1800;

// Cards & Content
export const BP_CARD_HORIZONTAL = 1000;
export const BP_CONTENT_MAX_WIDTH = 1750;

// Modals
export const BP_MODAL_SIZING = 1111;
